import { ca } from '@cian/analytics';
import { useUpdateEffect } from '@cian/react-utils';

import { type FC } from 'react';

import { ListingContext } from '@/microfrontends/listing/shared/context/ListingAppContext';
import { type ListingAppContext } from '@/microfrontends/listing/shared/types/context';

import { useActivePinIdSelector } from '@/packages/redux-state/store/slices/mapControls';
import { type CianAnalyticsPageViewObject } from '@/packages/utils/analytics/CianAnalyticsPageViewObject';

import { ComplaintFlow } from '../ComplaintFlow';
import { ListingByPinContainer } from '../ListingByPinContainer/ListingByPinContainer';
import { ListingContainer } from '../ListingContainer/ListingContainer';

type ApplicationListingProps = {
  context: ListingAppContext;
  getPageView: () => CianAnalyticsPageViewObject;
};

export const ApplicationListingContainer: FC<ApplicationListingProps> = ({ context, getPageView }) => {
  const activePinId = useActivePinIdSelector();

  useUpdateEffect(() => {
    if (activePinId == null) {
      ca('pageviewSite', getPageView());
    }
  }, [activePinId, getPageView]);

  return (
    <ListingContext context={context}>
      {activePinId ? <ListingByPinContainer /> : <ListingContainer />}
      <ComplaintFlow />
    </ListingContext>
  );
};
